import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as viewerNomDayAction from "../../../store/viewer-report-nomday/action";

import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";

import {
  GET_NOMINATION_CONF,
  IMPORT_NOMINATION_DAY,
  baseUrl,
} from "../../../helpers/url_api_constant";

import { Link, useHistory } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { post, postUpload } from "../../../helpers/api_helper";

import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import classnames from "classnames";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { useLocation } from 'react-router-dom';
import { useDispatch } from "react-redux";
//i18n

function ViewerNominationDay(props) {

  let history = useHistory();

  const dispatch = useDispatch();
  const location = useLocation();
  const viewerNomDayListReducer = useSelector(state => state.ViewerReportNomDay);

  const permission = getPermission();

  const searchObj = location?.state?.goBack == true ? viewerNomDayListReducer.modelSearch : { UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 1, LOAD_TYPE: 0 };
  // const createObj = { UPLOAD_DESC: "", };

  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [activeTime, setActiveTime] = useState({ UPLOAD_DATE: "" });
  // const [tempSearch, setTempSearch] = useState({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [modelDeviceList, setModelDeviceList] = useState(location?.state?.goBack == true ? viewerNomDayListReducer.modelDeviceList : []);
  const [activeTab, setActiveTab] = useState("1");

  // DropDown Search
  const [dropDownSearchType, setDropDownSearchType] = useState(location?.state?.goBack == true ? viewerNomDayListReducer.dropDownSearchType : null);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchType = selected => {
    setDropDownSearchType(selected);
  };
  // Handle Set Value DropDown Search //

  const listData = [
    {
      Id: "1",
      GetDataTime: "01/05/2021 03:00 AM",
      DataDate: "01/05/2021",
      FileName: "Nomination_Day_TSO_01_05_2021.xlsx",
      Type: "Upload Excel",
      Status: "Active",
    },
    {
      Id: "2",
      GetDataTime: "01/05/2021 02:00 AM",
      DataDate: "01/05/2021",
      FileName: "Nomination_Day_TSO_01_05_2021.xlsx",
      Type: "Upload Excel",
      Status: "-",
    },
    {
      Id: "3",
      GetDataTime: "30/04/2021 03:00 AM",
      DataDate: "30/04/2021",
      FileName: "-",
      Type: "Auto load PMIS",
      Status: "Active",
    },
    {
      Id: "4",
      GetDataTime: "29/04/2021 02:00 AM",
      DataDate: "29/04/2021",
      FileName: "-",
      Type: "Refresh Manual PMIS",
      Status: "-",
    },
  ];

  const listType = [
    { label: "Excel", value: "Excel" },
    { label: "PMIS", value: "PMIS" },
    // { label: "Refresh Manual PMIS", value: "Refresh Manual PMIS" },
    // { label: "Auto load PMIS", value: "Auto load PMIS" },
  ];

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];

  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    page: location?.state?.goBack == true ? viewerNomDayListReducer.pagination.page : 1,
    sizePerPage: location?.state?.goBack == true ? viewerNomDayListReducer.pagination.sizePerPage : 100,
    onSizePerPageChange: (sizePerPage, page) => {
      dispatch(viewerNomDayAction.setPaginationToState({ sizePerPage, page }))
    },
    onPageChange: (page, sizePerPage) => {
      dispatch(viewerNomDayAction.setPaginationToState({ sizePerPage, page }))
    },
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        {permission.vRVN && (
          <>
            <OverButton
              onClick={() => {
                gotoPageViewerNominationDayDetail(row);
              }}
              color="primary"
              icon="fas fa-eye"
              label="View"
            />
            <OverButton
              onClick={() => {
                downloadExcel(row);
              }}
              color="success"
              icon="fas fa-file-download"
              label="Download Excel"
            />
          </>
        )}
      </div>
    );
  };

  const gotoPageViewerNominationDayDetail = row => {
    history.push("/viewer-nomination-day/" + row.PID + "/viewer-nomination-day-detail");
  };
  // Action Button//

  useEffect(function () {

    let UPLOADTYPE_NAME = dropDownSearchType != null ? dropDownSearchType.value : null;

    setSearchModel(preVent => ({
      ...preVent, UPLOADTYPE_NAME: UPLOADTYPE_NAME
    }));

    dispatch(viewerNomDayAction.setDropDownSearchType(dropDownSearchType))

  }, [dropDownSearchType]);

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  //Check active
  const CheckActive = (active) => {
    // console.log(type);
    let status = "";
    let color = "";

    if (active == 1) {
      status = "Active";
      color = "success";
    } else {
      status = "-";
      color = "";
    }

    return (
      <div>
        <span className={"badge badge-soft-" + color} style={{ fontSize: 12 }}>
          {status}
        </span>
      </div>
    );
  };
  //Check active

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      formatter: CountIndexRow,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
    },
    // {
    //   dataField: "UPLOAD_DATE",
    //   text: "Get Data Time",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "15%",
    //     fontSize: "14px",
    //   },
    //   style: {
    //     width: "15%",
    //   },
    //   sort: true,
    //   isDummyField: true,
    //   formatter: (cellContent, row) => FormatDate(row.UPLOAD_DATE, "DD/MM/YYYY, HH:mm:ss")
    // },
    {
      dataField: "UPLOAD_START",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.UPLOAD_START, "DD/MM/YYYY")
    },
    // {
    //   dataField: "UPLOAD_FILE",
    //   text: "File Name",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "20%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "20%",
    //     fontSize: "12px",
    //   },
    //   sort: true,
    // },
    {
      dataField: "UPLOADTYPE_NAME",
      text: "Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "STATUS_FLAG",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => CheckActive(row.STATUS_FLAG)
    },
    {
      dataField: "UPLOAD_DESC",
      text: "Description",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "25%",
        fontSize: "12px",
      },
      style: {
        width: "25%",
        fontSize: "12px",
      },
      // sort: true,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      align: "center",
      formatter: ButtonAction,
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
        // paddingLeft: "0.7%",
        // paddingRight: "0.5%",
      },
    },
  ];
  //headerColumn

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  //onInit//
  useEffect(function () {
    if (location?.state?.goBack != true) {
      resetSearch();
    }
    // resetModel();
    // setModelDeviceList(listData);
    // getMonthValue();

    ///fixed header table
    let tableId = "viewer-nomday-table";
    let scrollY = 211;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//


  const resetSearch = () => {
    setSearchModel({ UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 1, LOAD_TYPE: 0 });
    // setTempSearch({ UPLOAD_DATE: "", UPLOAD_TO_DATE: "", UPLOAD_START: "", UPLOAD_TO: "" });
    setDropDownSearchType(null);
    fetchData({ UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 1, LOAD_TYPE: 0 });
  };

  const resetModel = () => {
    setCreateModel(createObj);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  useEffect(() => {
    dispatch(viewerNomDayAction.setModelDeviceListToState(modelDeviceList))
  }, [modelDeviceList])

  const fetchData = async (searchData) => {
    dispatch(viewerNomDayAction.setSearchToState(searchData))
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_NOMINATION_CONF, searchData);
      // console.log(res);
      setModelDeviceList(res.data.nominateConfList);

      if (res.data.nominateConfList.length > 0) {
        setActiveTime(res.data.nominateConfList[0]);
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const downloadExcel = (row) => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelNominateDayFileEx?NOMINATECONF_PID=" + row.PID, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          row.UPLOAD_FILE
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {props.t("Nomination ( Day )")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report Viewer
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Nomination ( Day )
                        </li>
                      </ol>
                    </div>
                  </div>
                </CardBody>
              </Card>

              <Row>
                <Col sm="12">
                  <Card>
                    <CardBody>
                      <Row className="mt-0">
                        {/* <Col sm="3">
                          <FormGroup className="row mt-3">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Get Data Start
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_DATE: moment(value[0]).format("YYYY-MM-DD")

                                    })
                                  setTempSearch({
                                    ...tempSearch,
                                    UPLOAD_DATE: value[0]
                                  })
                                }}
                                value={tempSearch.UPLOAD_DATE}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-3">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Get Data End
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_TO_DATE: moment(value[0]).format("YYYY-MM-DD")

                                    })
                                  setTempSearch({
                                    ...tempSearch,
                                    UPLOAD_TO_DATE: value[0]
                                  })
                                }}
                                value={tempSearch.UPLOAD_TO_DATE}
                              />
                            </Col>
                          </FormGroup>
                        </Col> */}
                        <Col sm="3">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Start Gas Day
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_START: value[0]

                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_START: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_START}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              End Gas Day
                            </Label>
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control d-block"
                                placeholder="Select Date"
                                options={{
                                  altInput: true,
                                  altFormat: "d/m/Y",
                                  // altFormat: "F Y",
                                  dateFormat: "d/m/Y",
                                }}
                                onChange={(value) => {
                                  setSearchModel(
                                    {
                                      ...searchModel,
                                      UPLOAD_TO: value[0]
                                    })
                                  // setTempSearch({
                                  //   ...tempSearch,
                                  //   UPLOAD_TO: value[0]
                                  // })
                                }}
                                value={searchModel.UPLOAD_TO}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row mt-0">
                            <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                              Type
                            </Label>
                            <Col sm={8}>
                              <Select
                                placeholder="All"
                                isClearable={true}
                                value={dropDownSearchType}
                                onChange={handleSelectDropDownSearchType}
                                options={listType}
                                classNamePrefix="select2-selection"
                                styles={SelectStyle}
                              />
                            </Col>
                          </FormGroup>
                        </Col>
                        <Col sm="3">
                          <FormGroup className="row">
                            <div className="d-flex align-items-center justify-content-center">
                              <Button color="info" className="mt-0" onClick={() => onSearch()}>
                                <i className="fas fa-search"></i>
                                &nbsp; Search
                              </Button>

                              <Button color="warning" className="mt-0 ms-2" onClick={() => resetSearch()}>
                                <i className="fas fa-redo-alt"></i>
                                &nbsp; Reset
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                      {/* 
                      <Row className="mt-5">
                        <Nav tabs>
                          <NavItem>
                            <NavLink
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: activeTab === "1",
                              })}
                              onClick={() => {
                                setActiveTab("1");
                              }}
                            >
                              Nomination Day
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Row> */}

                      <Row className="mt-4">
                        <hr />
                      </Row>

                      <Row className="mt-0">
                        {/* <TabContent
                          activeTab={activeTab}
                          className="p-3 text-muted"
                        >
                          <TabPane tabId="1"> */}
                        <Col sm="12">
                          <div>
                            {/* className="table-responsive" */}
                            <BootstrapTable
                              id="viewer-nomday-table"
                              keyField="PID"
                              data={modelDeviceList}
                              columns={columns}
                              headerClasses="header-style"
                              rowStyle={rowStyleFontWhite}
                              // defaultSorted={defaultSorted}
                              pagination={paginationFactory(options)}
                            // hover
                            />
                          </div>
                        </Col>
                        {/* </TabPane>
                        </TabContent> */}
                      </Row>
                      {/* <hr /> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>


          </Row>
        </Container>


      </div>
    </React.Fragment>
  );
}

ViewerNominationDay.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ ViewerNominationDay }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ViewerNominationDay));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
